module.exports = __webpack_public_path__ + "assets/icons/arrived-nonactive-emoji.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/arrived-nonactive-emoji.png
// module id = ./src/styles/icons/emojies/arrived-nonactive-emoji.png
// module chunks = 0